import {useEffect, useState} from "react";
import {Button, Menu, MenuItem, Typography} from "@mui/material";
import {chartTypesMap} from "../../config";

export const ChartPicker = ({chartTypeSetter, currentValue}) => {
    const options = chartTypesMap.map(o => o.value);
    const optionNames = chartTypesMap.map(o => o.name);
    const [anchorElement, setAnchorElement] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState(options.indexOf(currentValue));

    useEffect(() => {
        const index = options.indexOf(currentValue);
        if (index >= 0) {
            setSelectedIndex(index);
        }
    }, [currentValue]);

    const handleClick = (event) => {
        setAnchorElement(event.currentTarget);
    };

    const handleMenuItemClick = (event, index) => {
        setAnchorElement(null);
        setSelectedIndex(index);
        chartTypeSetter(options[index]);
    };

    const handleClose = () => {
        setAnchorElement(null);
    };

    return (
        <div style={{marginLeft: 5}}>
            <Typography variant="h7" display="inline">Measure:</Typography>
            <Button onClick={handleClick}>{optionNames[selectedIndex]}</Button>
            <Menu id="PickerMenu" anchorEl={anchorElement} keepMounted open={Boolean(anchorElement)}
                  onClose={handleClose}>
                {options.map((o, index) => (
                    <MenuItem key={o} value={o} selected={selectedIndex === index}
                              onClick={(event) => handleMenuItemClick(event, index)}>{optionNames[index]}</MenuItem>
                ))}
            </Menu>
        </div>
    );
};